import React from 'react'

import { Button, Switch } from 'antd'
import styled from 'styled-components/macro'

import { useSelector, useDispatch } from 'react-redux'

import { setFilter } from '../../redux/filters/actions'

import ProductModelSelect from '../ProductModelSelect'
import MultiStoresSelect from '../MultiStoresSelect'
import ModelCategoryRadio from '../ModelCategoryRadio'
import ProductNameSelect from '../ProductNameSelect'
import ProductParentSelect from '../ProductParentSelect'
import BrandsRadio from '../BrandsRadio'

import { getFilterValueByKey } from '../../redux/filters/reducer'
import { useProducts } from '../ProductsProvider'
import WarehouseRadio from '../WarehouseRadio'

const CustomerCareToolbar = ({ onSearch }) => {
  const searchType = useSelector(getFilterValueByKey('searchType'))
  const store = useSelector(getFilterValueByKey('store'))
  const dispatch = useDispatch()
  const { loading } = useProducts()

  const showSublocations = useSelector(getFilterValueByKey('showSublocations'))
  const hideEmptyRows = useSelector(getFilterValueByKey('hideEmptyRows'))

  return (
    <FlexContainer>
      <MultiStoresSelect disabled={loading} />
      <FlexRow>
        <FlexItem>Cerca per:</FlexItem>
        <FlexItem>
          <ModelCategoryRadio disabled={loading} />
        </FlexItem>
        <FlexItem>
          {searchType === 'productName' && (
            <>
              <ProductNameSelect disabled={loading} />
              <Switch
                defaultChecked={false}
                style={{ marginLeft: '10px' }}
                disabled={loading}
                onChange={e => {
                  dispatch(
                    setFilter({
                      key: 'showAll',
                      value: e,
                    }),
                  )
                }}
              />
              <span style={{ marginLeft: '10px' }}>
                Mostra tutta la categoria
              </span>
            </>
          )}
          {searchType === 'productModel' && (
            <ProductModelSelect disabled={loading} />
          )}
          {searchType === 'productParent' && (
            <ProductParentSelect disabled={loading} onPressEnter={onSearch} />
          )}
        </FlexItem>
        <FlexItem>
          <Button
            type="primary"
            onClick={onSearch}
            disabled={!store || store.length === 0 || loading}
          >
            Search
          </Button>
        </FlexItem>
      </FlexRow>
      <FlexRow>
        <FlexItem>Filtra per:</FlexItem>
        <FlexItem>
          <WarehouseRadio />
        </FlexItem>
        <FlexItem>
          {searchType !== 'productParent' && (
            <BrandsRadio defaultValue="all" disabled={loading} />
          )}
        </FlexItem>
        <FlexItem>
          <Switch
            defaultChecked={showSublocations}
            disabled={loading}
            onChange={e => {
              dispatch(
                setFilter({
                  key: 'showSublocations',
                  value: e,
                }),
              )
            }}
          />{' '}
          Mostra dettaglio
        </FlexItem>
        <FlexItem>
          <Switch
            defaultChecked={hideEmptyRows}
            disabled={loading}
            onChange={e => {
              dispatch(
                setFilter({
                  key: 'hideEmptyRows',
                  value: e,
                }),
              )
            }}
          />{' '}
          Nascondi righe vuote
        </FlexItem>
      </FlexRow>
    </FlexContainer>
  )
}

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 15px;
`

const FlexRow = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

const FlexItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export default CustomerCareToolbar
